import { BankApplication } from '@modules/opportunities/entities/bankApplication/bankApplication.entity';
import { Opportunity } from '@modules/opportunities/entities/opportunity/opportunity.entity';

export const bodyDefaultValue = (opportunityData: Opportunity, bankApplication: BankApplication) => {
  const mainApplicant = opportunityData.applicants.find((applicant) => applicant.applicant_type === 'main');
  return `
      <div>
          <p>Dear,</p>
          <p>Kindly process the below application</p>
          <p>Case details:</p>
          <ul>
              <li>Customer name: ${mainApplicant?.first_name} ${mainApplicant?.last_name}</li>
              <li>Customer mobile number: ${mainApplicant?.mobile}</li>
              <li>Customer email: ${mainApplicant?.email}</li>
              <li>Property value: AED ${opportunityData.property_value}</li>
              <li>Loan Amount: AED ${opportunityData.amount}</li>
              <li>Transaction type: ${opportunityData.type_of_transaction}</li>
              <li>Mortgage type: ${bankApplication.mortgage_type}</li>
              <li>Customer profile: ${mainApplicant?.employment_details?.employment_type}</li>
              <li>Resident Status: ${mainApplicant?.citizen_status}</li>
              <li>LTV: ${(opportunityData.amount / opportunityData.property_value!) * 100}%</li>
              <li>Fee Finance: ${opportunityData.is_fee_financed}</li>
              <li>Rate: ${bankApplication.bank_details.selected_rate.fixed_rate}%</li>
              <li>Tenor: ${bankApplication.mortgage_length_months}</li>
              <li>Salary: AED ${mainApplicant?.incomes?.find((income) => income.type === 'salary')?.amount || 0}</li>
              <li>Liabilities: </li>
          </ul>
      </div>
    `;
};

export const subjectDefaultValue = (opportunityData: Opportunity, bankApplication: BankApplication) => {
  const mainApplicant = opportunityData.applicants.find((applicant) => applicant.applicant_type === 'main');
  const part1 = `New Application - ${bankApplication.bank_details.name}`;
  const part2 = `${mainApplicant?.first_name} ${mainApplicant?.last_name}`;
  const part3 = `${mainApplicant?.employment_details?.employment_type} - ${opportunityData.type_of_transaction}`;
  return `${part1} - ${part2} - ${part3} `;
};
